var _rect, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path, _path2, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHonestiIqDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 380",
    fill: "none",
    role: "img",
    "aria-label": "CRM dashboard analytics",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 380,
    rx: 20,
    fill: "#F4F2FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 512,
    height: 36,
    rx: 10,
    fill: "#fff",
    stroke: "#E6DDF5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 42,
    r: 6,
    fill: "#9e00ff",
    opacity: 0.35
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 36,
    width: 120,
    height: 12,
    rx: 6,
    fill: "#002454",
    opacity: 0.15
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 32,
    width: 72,
    height: 20,
    rx: 10,
    fill: "#9e00ff",
    opacity: 0.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 76,
    width: 120,
    height: 88,
    rx: 14,
    fill: "#fff",
    stroke: "#E6DDF5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 92,
    width: 56,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 108,
    width: 88,
    height: 18,
    rx: 6,
    fill: "#9e00ff",
    opacity: 0.85
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 136,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#25C16F",
    opacity: 0.55
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 76,
    width: 120,
    height: 88,
    rx: 14,
    fill: "#fff",
    stroke: "#E6DDF5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 92,
    width: 56,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 108,
    width: 88,
    height: 18,
    rx: 6,
    fill: "#002454",
    opacity: 0.75
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 136,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#9e00ff",
    opacity: 0.45
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 76,
    width: 248,
    height: 88,
    rx: 14,
    fill: "#fff",
    stroke: "#E6DDF5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 92,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 148 330 124 360 132 390 108 420 118 450 96 480 112 512 88",
    stroke: "#9e00ff",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300 148 330 132 360 140 390 120 420 128 450 112 480 124 512 104",
    stroke: "#002454",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.35
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 180,
    width: 512,
    height: 176,
    rx: 14,
    fill: "#fff",
    stroke: "#E6DDF5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 196,
    width: 96,
    height: 10,
    rx: 5,
    fill: "#002454",
    opacity: 0.18
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 220,
    width: 468,
    height: 12,
    rx: 6,
    fill: "#F4F2FA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 220,
    width: 320,
    height: 12,
    rx: 6,
    fill: "#9e00ff",
    opacity: 0.75
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 246,
    width: 468,
    height: 12,
    rx: 6,
    fill: "#F4F2FA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 246,
    width: 280,
    height: 12,
    rx: 6,
    fill: "#002454",
    opacity: 0.55
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 272,
    width: 468,
    height: 12,
    rx: 6,
    fill: "#F4F2FA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 272,
    width: 360,
    height: 12,
    rx: 6,
    fill: "#9e00ff",
    opacity: 0.45
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 298,
    width: 468,
    height: 12,
    rx: 6,
    fill: "#F4F2FA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 298,
    width: 240,
    height: 12,
    rx: 6,
    fill: "#25C16F",
    opacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonestiIqDashboard);
export default __webpack_public_path__ + "static/media/honesti-iq-dashboard.44bd40e295c3614029cac2561d8ca2c5.svg";
export { ForwardRef as ReactComponent };